import { DropDownBox, List } from "devextreme-react";
import React, { useCallback, useState } from "react";
import "../customDropDown/CustomDropdown.scss";

export default function CustomDropdown({
  label,
  placeholder,
  mySelectMode,
  myDataSource,
  setSelectedValue,
  noRequired,
  value,
  width,
}) {
  const [isOpened, setIsOpened] = useState(false);

  const syncSelection = useCallback(
    (e) => {
      const selectedItem = myDataSource.find((item) => item.value === e.value);

      if (setSelectedValue) {
        setSelectedValue(selectedItem);
      }
    },
    [setSelectedValue, myDataSource],
  );

  const onDropDownBoxOpened = useCallback((e) => {
    if (e.name === "opened") {
      setIsOpened(e.value);
    }
  }, []);

  const onItemClick = (item) => {
    if (setSelectedValue) {
      setSelectedValue(item);
    }
    setIsOpened(false);
  };

  const contentRender = useCallback(
    () => (
      <List
        dataSource={myDataSource}
        displayExpr="text"
        selectionMode={
          mySelectMode && mySelectMode === "multiple" ? "all" : "single"
        }
        showSelectionControls={
          mySelectMode && mySelectMode === "multiple" ? true : false
        }
        selectAllMode={"allPages"}
        selectByClick={true}
        onItemClick={(e) => onItemClick(e.itemData)}
      />
    ),
    [myDataSource],
  );
  return (
    <div className="MyDropDown">
      <label className="ddLabel">
        {label}{" "}
        {label && (
          <span className="requiredClass">
            {noRequired === "no" ? "" : "*"}
          </span>
        )}
      </label>
      <div className="ddWrapper">
        <DropDownBox
          className="ddMain"
          stylingMode="outlined"
          value={value}
          opened={isOpened}
          valueExpr="value"
          displayExpr="text"
          placeholder={placeholder}
          dataSource={myDataSource}
          onValueChanged={syncSelection}
          onOptionChanged={onDropDownBoxOpened}
          contentRender={contentRender}
          width={width}
        />
      </div>
    </div>
  );
}
